module.exports = __webpack_public_path__ + "static/avatar_twixi_twins@2x-a217841ee07d91c57c3311a9c77563fb.jpg";